// Selectors for checkSessionUrl
export const selectCheckSessionUrlData = (state) => state.sessionUrl.checkSessionUrl.data;
export const selectCheckSessionUrlLoading = (state) => state.sessionUrl.checkSessionUrl.loading;
export const selectCheckSessionUrlError = (state) => state.sessionUrl.checkSessionUrl.error;

// Selectors for submitSessionUrl
export const selectSubmitSessionUrlData = (state) => state.sessionUrl.submitSessionUrl.data;
export const selectSubmitSessionUrlLoading = (state) => state.sessionUrl.submitSessionUrl.loading;
export const selectSubmitSessionUrlError = (state) => state.sessionUrl.submitSessionUrl.error;
